<template>
  <div>
    <div class="profile-field__title">Навыки</div>
    <div v-if="field.skills.language.show" class="skill-block">
      <c-item
        v-for="(item, i) in languages"
        :key="item.unique"
        class="skill"
        :item="item"
        :config="field.skills.language"
        :options="languageOptions"
        :level-options="languageLevelOptions"
        skill-label="Иностранный язык"
        :can-remove="true"
        :error="error && error.languages.items[i]"
        @remove="removeLanguage(item)"
      />

      <c-button
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить язык"
        :disabled="preview || hasEmptyLanguages"
        size="small"
        @click="addLanguage"
      />

      <error-feedback v-if="error && error.languages.common" :text="error && error.languages.common" />
    </div>

    <div v-if="field.skills.program.show" class="skill-block">
      <c-item
        v-for="(item, i) in programs"
        :key="item.unique"
        class="skill"
        :item="item"
        :config="field.skills.program"
        :options="programOptions"
        :level-options="programLevelOptions"
        skill-label="Программа"
        :can-remove="true"
        :error="error && error.programs.items[i]"
        @remove="removeProgram(item)"
      />

      <c-button
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить программу"
        :disabled="preview || hasEmptyPrograms"
        size="small"
        @click="addProgram"
      />

      <error-feedback v-if="error && error.programs.common" :text="error && error.programs.common" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import CItem from "./item";

import { SYSTEM_TYPES, FIELD_TYPE_SKILLS } from "@/domains/profile/constants/system-types";
import { formatList } from "../../utils";
import { SkillModel, formatSkillModel, isEmptySkill } from "./utils";

const fieldConfig = SYSTEM_TYPES[FIELD_TYPE_SKILLS];

export default {
  components: { CButton, CItem, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      programs: [],
      languages: [],
    };
  },

  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),

    programOptions() {
      const { programs } = fieldConfig.dictionaryCodes;
      return formatList(this.dictionaries[programs]);
    },
    programLevelOptions() {
      const { programLevels } = fieldConfig.dictionaryCodes;
      return formatList(this.dictionaries[programLevels]);
    },

    languageOptions() {
      const { languages } = fieldConfig.dictionaryCodes;
      return formatList(this.dictionaries[languages]);
    },

    languageLevelOptions() {
      const { languageLevels } = fieldConfig.dictionaryCodes;
      return formatList(this.dictionaries[languageLevels]);
    },

    hasEmptyLanguages() {
      return this.languages.some(isEmptySkill);
    },

    hasEmptyPrograms() {
      return this.programs.some(isEmptySkill);
    },
  },

  watch: {
    languages: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    programs: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    value(v) {
      this.setData(v);
    },
  },

  async created() {
    await Promise.all(
      Object.values(fieldConfig.dictionaryCodes).map((code) => this.$store.dispatch("profile/getDictionary", { code })),
    );
    if (this.value) this.setData(this.value);
    if (!this.programs.length  && this.field.skills.program.required) this.addProgram();
    if (!this.languages.length  && this.field.skills.language.required) this.addLanguage();
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { languages, programs } = value.value || {};

      const currentLanguages = this.languages.map(formatSkillModel);
      const currentPrograms = this.programs.map(formatSkillModel);

      if (JSON.stringify(languages) !== JSON.stringify(currentLanguages)) {
        this.languages = (languages || []).map(SkillModel);
      }

      if (JSON.stringify(programs) !== JSON.stringify(currentPrograms)) {
        this.programs = (programs || []).map(SkillModel);
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      const newLanguages = this.languages.map(formatSkillModel);
      const newPrograms = this.programs.map(formatSkillModel);
      const newValue = {
        value: {
          languages: newLanguages,
          programs: newPrograms,
        },
      };

      this.$emit("input", newValue);
      if (this.inited) this.$emit("change");
    },
    addProgram() {
      this.programs = [...this.programs, SkillModel()];
    },
    addLanguage() {
      this.languages = [...this.languages, SkillModel()];
    },
    removeLanguage(lang) {
      this.languages = this.languages.filter((l) => l !== lang);
    },
    removeProgram(program) {
      this.programs = this.programs.filter((p) => p !== program);
    },
  },
};
</script>

<style lang="scss" scoped>
.skill-block + .skill-block {
  margin-top: 25px;
}
</style>
